import { ChevronDown, CloudUpload } from 'lucide-react';
import { useState } from 'react';
import { useCurrentUserRole } from '~entities/users/hooks/use-current-user-role';

import { AttendanceExportFormatDialog } from '~shared/components/attendance-export-format-dialog';
import {
  type ExportFormat,
  useAttendanceExport,
} from '~shared/hooks/useAttendanceExport';
import { Button } from '~shared/shadcn/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~shared/shadcn/ui/dropdown-menu';

interface AttendanceExportDropdownProps {
  entityId: string;
  entityTitle?: string;
}

export const AttendanceExportDropdown = ({
  entityId,
  entityTitle,
}: AttendanceExportDropdownProps) => {
  const { exportAttendanceSheet, isExporting } = useAttendanceExport({
    entityId,
    entityTitle,
  });

  const [formatDialogOpen, setFormatDialogOpen] = useState(false);
  const [selectedShowBalance, setSelectedShowBalance] =
    useState<boolean>(false);

  const handleBalanceOptionClick = (showBalance: boolean) => {
    setSelectedShowBalance(showBalance);
    setFormatDialogOpen(true);
  };

  const handleFormatSelect = (format: ExportFormat) => {
    void exportAttendanceSheet(selectedShowBalance, format);
  };

  const { hasAdminAccess } = useCurrentUserRole();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant='outline' disabled={isExporting}>
            <CloudUpload className='mr-2 size-4' />
            {isExporting ? 'Exporting...' : 'Attendance Sheet'}
            <ChevronDown className='ml-2 size-4' />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end'>
          <DropdownMenuItem
            onClick={() => {
              handleBalanceOptionClick(false);
            }}
            disabled={isExporting}
          >
            Export without balances
          </DropdownMenuItem>
          {
            hasAdminAccess && (
              <DropdownMenuItem
              onClick={() => {
                handleBalanceOptionClick(true);
              }}
              disabled={isExporting}
            >
              Export with balances
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      <AttendanceExportFormatDialog
        open={formatDialogOpen}
        onOpenChange={setFormatDialogOpen}
        onFormatSelect={handleFormatSelect}
        showBalance={selectedShowBalance}
      />
    </>
  );
};
